import {
  alpha,
  Checkbox,
  FormControlLabel,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import i18n from 'i18next';
import { useFormContext } from 'react-hook-form';

import { Allergen, getContentLanguage, useAllergens } from '@/core';
import palette from '@/theme/palette.ts';

type AllergenPickerProps = {
  label: string;
  sx?: SxProps<Theme>;
};

export const AllergenPicker = ({ label, sx }: AllergenPickerProps) => {
  const { setValue, watch } = useFormContext();
  const selectedAllergens: Allergen[] = watch('allergens');
  const { allergensResult } = useAllergens();
  const { data: allergens } = allergensResult;

  const handleAllergenChange = (allergen: Allergen) => {
    const isSelected = selectedAllergens.some((a) => a.id === allergen.id);
    const newSelectedAllergens = isSelected
      ? selectedAllergens.filter((a) => a.id !== allergen.id)
      : [...selectedAllergens, allergen];
    setValue('allergens', newSelectedAllergens);
  };

  return (
    <Stack direction="column" gap={2}>
      <Typography variant="body1" fontWeight={500}>
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" maxWidth="620px" sx={sx}>
        {allergens?.map((allergen) => (
          <FormControlLabel
            key={allergen.id}
            control={
              <Checkbox
                checked={selectedAllergens.some((a) => a.id === allergen.id)}
                onChange={() => handleAllergenChange(allergen)}
                name={allergen.name[getContentLanguage(i18n.language)]}
              />
            }
            label={allergen.name[getContentLanguage(i18n.language)]}
            sx={{
              '.MuiTypography-root': { fontSize: '14px' },
              backgroundColor: 'white',
              borderRadius: '25px',
              pr: 1,
              '&:hover': {
                backgroundColor: alpha(palette.primary.main, 0.03),
              },
              transition: 'all 0.1s ease-in-out',
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};
